import { ValidationMessages } from "globalConstants";
import { isEmailAllowed } from "helpers";

type CheckIfEmailExistReduxProps = {
	emailValue: string;
	emailInitialValue: string | undefined;
	emailPrevValue: string;
	setEmailPrevValue: (email: string) => void;
	isEmailExist: boolean;
	setIsEmailExist: (flag: boolean) => void;
	setAllowedDomains?: (domains: string[]) => void;
	checkIfEmailUnique: (email: string) => Promise<any>;
	getWhitelistedDomains?: ({
		companyId,
	}: {
		companyId: string;
	}) => Promise<any>;
	companyId?: string;
	companyIdPrevValue?: string;
	setCompanyIdPrevValue?: (companyId: string) => void;
};

const checkIfEmailExistRedux = async ({
	emailValue,
	emailInitialValue,
	emailPrevValue,
	setEmailPrevValue,
	isEmailExist,
	setIsEmailExist,
	setAllowedDomains,
	checkIfEmailUnique,
	getWhitelistedDomains,
	companyId,
	companyIdPrevValue,
	setCompanyIdPrevValue,
}: CheckIfEmailExistReduxProps) => {
	let message = "";

	const getWhitelistedDomainsFn = async (email, companyId) =>
		await getWhitelistedDomains?.({ companyId }).then(async domains => {
			if (!isEmailAllowed(email, domains)) {
				await setAllowedDomains?.(domains);
				message = ValidationMessages.NotAllowedEmail;
			}
		});

	if (
		companyId !== companyIdPrevValue &&
		!isEmailExist &&
		getWhitelistedDomains
	) {
		setCompanyIdPrevValue?.(companyId || "");
		setAllowedDomains?.([]);

		try {
			await getWhitelistedDomainsFn(emailValue, companyId);
		} catch {}
	}

	if (
		emailValue === emailPrevValue &&
		emailValue !== emailInitialValue &&
		isEmailExist
	) {
		return Promise.resolve(ValidationMessages.EmailExist);
	}

	setEmailPrevValue(emailValue);

	if (
		emailValue?.length &&
		emailValue !== emailInitialValue &&
		emailValue !== emailPrevValue
	) {
		setIsEmailExist(false);
		setAllowedDomains?.([]);

		try {
			await checkIfEmailUnique(emailValue).then(async res => {
				if (res.user_email_exists === true) {
					setIsEmailExist(true);
					message = ValidationMessages.EmailExist;
				} else if (getWhitelistedDomains) {
					await getWhitelistedDomainsFn(emailValue, companyId);
				}
			});
		} catch {}
	}

	return Promise.resolve(message);
};

export default checkIfEmailExistRedux;
